import React from 'react';
import { DollarSign, FileText, CheckCircle, MessageSquare, ArrowRight, AlertCircle, Clock, XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Dashboard() {
  return <div className="p-8 max-w-7xl mx-auto" data-id="element-1279">
      <h1 className="text-2xl font-bold text-brand-navy mb-6" data-id="element-1280">Dashboard</h1>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1281">
        <KpiCard title="Total Collected This Month" value="$48,320" icon={DollarSign} trend="+12%" trendUp data-id="element-1282" />
        <KpiCard title="Active Payment Plans" value="142" icon={FileText} trend="+5" trendUp data-id="element-1283" />
        <KpiCard title="Pending Settlements" value="23" icon={CheckCircle} trend="-2" trendUp={false} data-id="element-1284" />
        <KpiCard title="Unread Messages" value="7" icon={MessageSquare} alert data-id="element-1285" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1286">
        {/* Recent Activity */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm flex flex-col h-[500px]" data-id="element-1287">
          <div className="p-5 border-b border-gray-200 flex justify-between items-center shrink-0" data-id="element-1288">
            <h2 className="font-bold text-brand-navy" data-id="element-1289">Recent Activity</h2>
            <button className="text-sm text-brand-navy hover:text-brand-red font-medium transition-colors" data-id="element-1290">
              View All
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-5 space-y-6" data-id="element-1291">
            <ActivityRow type="payment" consumer="Lissette Berpan" detail="Payment received: $707.36" time="10 mins ago" data-id="element-1292" />
            <ActivityRow type="plan" consumer="Michael Chang" detail="New payment plan set up (12 mo)" time="1 hour ago" data-id="element-1293" />
            <ActivityRow type="message" consumer="Sarah Jenkins" detail="Sent SMS regarding settlement" time="2 hours ago" data-id="element-1294" />
            <ActivityRow type="offer" consumer="David Smith" detail="Created settlement offer: $2,500" time="3 hours ago" data-id="element-1295" />
            <ActivityRow type="payment" consumer="Amanda Cole" detail="Payment received: $150.00" time="4 hours ago" data-id="element-1296" />
            <ActivityRow type="message" consumer="Robert Fox" detail="Received email reply" time="5 hours ago" data-id="element-1297" />
          </div>
        </div>

        {/* Follow-ups Needed */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm flex flex-col h-[500px]" data-id="element-1298">
          <div className="p-5 border-b border-gray-200 flex justify-between items-center shrink-0" data-id="element-1299">
            <h2 className="font-bold text-brand-navy" data-id="element-1300">Follow-ups Needed</h2>
            <span className="bg-red-100 text-brand-red text-xs font-bold px-2 py-1 rounded-full" data-id="element-1301">
              12 Pending
            </span>
          </div>
          <div className="flex-1 overflow-y-auto p-0" data-id="element-1302">
            <FollowUpRow consumer="James Wilson" reason="Offer Expiring" date="Today" urgent data-id="element-1303" />
            <FollowUpRow consumer="Elena Rodriguez" reason="Payment Failed" date="Yesterday" urgent data-id="element-1304" />
            <FollowUpRow consumer="Marcus Johnson" reason="No Response" date="Jun 12" data-id="element-1305" />
            <FollowUpRow consumer="Sophie Chen" reason="Requested Callback" date="Jun 11" data-id="element-1306" />
            <FollowUpRow consumer="William Taylor" reason="Offer Expiring" date="Jun 10" data-id="element-1307" />
          </div>
        </div>
      </div>
    </div>;
}
function KpiCard({
  title,
  value,
  icon: Icon,
  trend,
  trendUp,
  alert
}: any) {
  return <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col" data-id="element-1308">
      <div className="flex justify-between items-start mb-4" data-id="element-1309">
        <div className={`p-3 rounded-lg ${alert ? 'bg-red-50 text-brand-red' : 'bg-gray-50 text-brand-navy'}`} data-id="element-1310">
          <Icon size={20} data-id="element-1311" />
        </div>
        {trend && <span className={`text-xs font-bold px-2 py-1 rounded-full ${trendUp ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-1312">
            {trend}
          </span>}
        {alert && <span className="w-2.5 h-2.5 bg-brand-red rounded-full" data-id="element-1313"></span>}
      </div>
      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-1314">{title}</p>
      <p className="text-3xl font-bold text-brand-navy" data-id="element-1315">{value}</p>
    </div>;
}
function ActivityRow({
  type,
  consumer,
  detail,
  time
}: any) {
  const icons = {
    payment: {
      icon: DollarSign,
      bg: 'bg-green-100 text-green-600'
    },
    plan: {
      icon: FileText,
      bg: 'bg-blue-100 text-blue-600'
    },
    message: {
      icon: MessageSquare,
      bg: 'bg-purple-100 text-purple-600'
    },
    offer: {
      icon: CheckCircle,
      bg: 'bg-amber-100 text-amber-600'
    }
  };
  const config = icons[type as keyof typeof icons];
  const Icon = config.icon;
  return <div className="flex gap-4" data-id="element-1316">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${config.bg}`} data-id="element-1317">
        <Icon size={18} data-id="element-1318" />
      </div>
      <div data-id="element-1319">
        <p className="text-sm font-bold text-brand-navy" data-id="element-1320">{consumer}</p>
        <p className="text-sm text-gray-600" data-id="element-1321">{detail}</p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-1322">{time}</p>
      </div>
    </div>;
}
function FollowUpRow({
  consumer,
  reason,
  date,
  urgent
}: any) {
  return <div className="flex items-center justify-between p-5 border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-1323">
      <div className="flex items-center gap-4" data-id="element-1324">
        <div className={`w-2 h-2 rounded-full ${urgent ? 'bg-brand-red' : 'bg-amber-400'}`} data-id="element-1325"></div>
        <div data-id="element-1326">
          <p className="text-sm font-bold text-brand-navy" data-id="element-1327">{consumer}</p>
          <div className="flex items-center gap-2 mt-1" data-id="element-1328">
            <span className="text-xs font-medium text-gray-500" data-id="element-1329">{reason}</span>
            <span className="text-gray-300" data-id="element-1330">•</span>
            <span className={`text-xs font-medium ${urgent ? 'text-brand-red' : 'text-gray-400'}`} data-id="element-1331">
              Due: {date}
            </span>
          </div>
        </div>
      </div>
      <Link to="/portal/admin/consumers" className="px-3 py-1.5 text-xs font-bold text-brand-navy border border-gray-200 rounded hover:bg-gray-100 transition-colors" data-id="element-1332">
        View
      </Link>
    </div>;
}